import axios from "axios";
import Config from "../utils/Config";
import Middleware from "./Middleware";

class PaperCategoryService {

    config = {
        headers: {
            Authorization: "",
            CompanyId: "",
        },
    };

    //set access token
    setAccessToken(accessToken, companyId) {
        this.config.headers.Authorization = accessToken;
        this.config.headers.CompanyId = companyId;
    }

    // GET paper category list for committee
    async getPaperCategoryList(selectedCommitteeID, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);

        const res = await Middleware.api.get(
            `/apiVWeb/meetingAgendaCategory/byCommitteeId/${selectedCommitteeID}`,
            this.config
        )
        return res;
    }

    // GET singlepaper category
    async getSinglePaperCategory(selectedPaperCategoryID, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);

        const res = await Middleware.api.get(
            `/apiVWeb/meetingAgendaCategory/byId/${selectedPaperCategoryID}`,
            this.config
        )
        return res;
    }

    // POST paper category
    async createPaperCategory(selectedCommitteeID, formData, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);

        const res = await Middleware.api.post(
            `/apiVWeb/meetingAgendaCategory/${selectedCommitteeID}`,
            formData,
            this.config
        )
        return res;
    }

    // PUT paper category edit
    async updateSinglePaperCategory(selectedPaperCategoryID, formData, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);

        const res = await Middleware.api.put(
            `/apiVWeb/meetingAgendaCategory/${selectedPaperCategoryID}`,
            formData,
            this.config
        )
        return res;
    }

    // PATCH paper category status change
    async updatePaperCategoryStatus(selectedPaperCategoryID, formData, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);

        const res = await Middleware.api.patch(
            `/apiVWeb/meetingAgendaCategory/${selectedPaperCategoryID}`,
            formData,
            this.config
        )
        return res;
    }
    
    // DELETE paper category
    async deleteSinglePaperCategory(selectedPaperCategoryID, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);

        const res = await Middleware.api.delete(
            `/apiVWeb/meetingAgendaCategory/${selectedPaperCategoryID}`,
            this.config
        )
        return res;
    }
};

export default new PaperCategoryService();